import React from 'react';
export function PaymentBadges({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex flex-wrap items-center justify-center gap-2 ${className}`} data-id="element-215">
      {/* Visa */}
      <div className="flex items-center justify-center px-3 py-1.5 bg-[#1434CB] rounded-md shadow-sm h-8" data-id="element-216">
        <span className="text-white font-bold text-xs italic tracking-wider" data-id="element-217">
          VISA
        </span>
      </div>

      {/* Mastercard */}
      <div className="flex items-center justify-center px-3 py-1.5 bg-gradient-to-br from-red-500 to-orange-500 rounded-md shadow-sm h-8" data-id="element-218">
        <div className="flex -space-x-2" data-id="element-219">
          <div className="w-4 h-4 rounded-full bg-red-600 opacity-80 mix-blend-multiply" data-id="element-220"></div>
          <div className="w-4 h-4 rounded-full bg-yellow-400 opacity-80 mix-blend-multiply" data-id="element-221"></div>
        </div>
      </div>

      {/* PayPal */}
      <div className="flex items-center justify-center px-3 py-1.5 bg-[#003087] rounded-md shadow-sm h-8" data-id="element-222">
        <span className="text-white font-bold text-xs italic" data-id="element-223">PayPal</span>
      </div>

      {/* Amex */}
      <div className="flex items-center justify-center px-3 py-1.5 bg-[#2E77BC] rounded-md shadow-sm h-8" data-id="element-224">
        <span className="text-white font-bold text-[10px] tracking-widest" data-id="element-225">
          AMEX
        </span>
      </div>

      {/* Apple Pay */}
      <div className="flex items-center justify-center px-3 py-1.5 bg-black rounded-md shadow-sm h-8" data-id="element-226">
        <span className="text-white font-semibold text-xs flex items-center gap-1" data-id="element-227">
          Pay
        </span>
      </div>
    </div>;
}